import React from 'react'
import ToLandscapeSvg from 'images/modules/Manage/i-to-landscape.svg?raw'

export { default as ToLandscapeUrl} from 'images/modules/Manage/i-to-landscape.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ToLandscapeSvg}} />
)
